import React from 'react'

function Footer () {
    return (
        <div className="bg-footer">
			<div className="pull-right">
				SOPORTE TÉCNICO: 
				<a href="mailto: soporte@trie.mx" style={{color: 'white'}}>soporte@trie.mx</a>
			</div>
		</div>
    );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/layout/footer.js